export default __webpack_public_path__ + "192d71bd61e9536ca34e3ea6d4f279ee.svg";